import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20flowing%20lines%2C%20coral%20and%20amber%20tones%2C%20modern%20minimalist%20design%2C%20soft%20glow%20effects%2C%20warm%20atmospheric%20light%2C%20elegant%20texture%2C%20professional%20background%20for%20Chinese%20website&width=1800&height=600&seq=cta-bg-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
            有料要爆？加入每日吃瓜
          </h2>
          <p className="text-white/70 text-sm md:text-base mb-8 leading-relaxed">
            如果你是知情人士，掌握一手内幕消息，欢迎来稿爆料。
            我们保护每一位爆料人的隐私安全，让你的声音被更多人听到。
          </p>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 bg-primary-500 text-white px-8 py-3 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-mail-send-line"></i>
            联系投稿
          </Link>
        </div>
      </div>
    </section>
  );
}